import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../routes/loadEndpoint'
import type {Branch} from '../../../services/rest'
import {restApi} from '../../../services/rest'
import type {BuildTypeId} from '../../../types'

import {finishedLink, pinnedLink, successfulLink} from './Permalinks.consts'
import {getPermalinkArg} from './Permalinks.utils'

export const preloadPermalinks =
  (buildTypeId: BuildTypeId, branch?: Branch | null | undefined): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const result: LoadedEndpoints = []

    const pinnedArg = getPermalinkArg({buildTypeId, branch, type: pinnedLink.type})
    const successfulArg = getPermalinkArg({buildTypeId, branch, type: successfulLink.type})
    const finishedArg = getPermalinkArg({buildTypeId, branch, type: finishedLink.type})

    if (pinnedArg) {
      result.push(dispatch(loadEndpoint(restApi.endpoints.getAllBuilds, pinnedArg)))
    }
    if (successfulArg) {
      result.push(dispatch(loadEndpoint(restApi.endpoints.getAllBuilds, successfulArg)))
    }
    if (finishedArg) {
      result.push(dispatch(loadEndpoint(restApi.endpoints.getAllBuilds, finishedArg)))
    }
    return result
  }
